import {
  useGetBlockByDistrictQuery,
  useGetDistrictByStateQuery,
  useGetStatesQuery,
} from "services/locationApiSlice";
import {
  useGetAssignedFarmersQuery,
  useGetFarmersQuery,
} from "./farmerApiSlice";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pagination } from "@mui/material";
import { Tag } from "antd";
import { setBreadcrumbs } from "app/appSlice";
import CustomSearchBar from "components/CustomSearchBar";
import ListViewActionItems from "components/ListViewActionItems";
import ListViewContainer from "components/ListViewContainer";
import { selectCurrentUser } from "features/auth/authSlice";
import { useEffect, useState, useRef } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import Select from "react-select";
import { Card, CardBody, CardHeader } from "reactstrap";
import FarmerMap from "./FarmerMap";
import FarmerRequest from "./FarmerRequest";
import {
  CheckCircleOutlined,
  FileTextOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Tab, Tabs } from "@mui/material";
import TaskDetails from "./TaskDetails";
import HCLMap from "components/HclDashboard/HCLMap";
import ProjectMap from "features/dashboard/Project/ProjectMap";
import { useGetSaathiFLEQuery } from "features/CrmDashboardComp/CmrApiSlice";
import { useGetCropListQuery } from "features/dashboard/RiskManagement/RiskManagementApiSlice";
import SortDropdown from "./SortDropdown";
import { ProjectCharts } from "features/dashboard/Project/ProjectCharts";
import { ProjectSideAnalytics } from "features/dashboard/Project/ProjectSideAnalytics";
import { useGetFPOListQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import Skeleton from "react-loading-skeleton";
import { DateRangePicker } from "rsuite";
import "leaflet/dist/leaflet.css";

const FarmerList = ({
  showMap = true,
  setGeojsonInParent = () => {},
  projectExist,
}) => {
  const { id } = useParams();
  console.log("farmer id", id);
  const navigate = useNavigate();
  const location = useLocation();
  const noSidebar = location?.pathname?.includes("project");
  const orgId = id ? id : "";
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const [farmers, setFarmers] = useState([]);
  const [showGeojson, setGeojsonData] = useState();
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    per_page: 50,
  });
  const [paginationAss, setPaginationAss] = useState({ page: 1, pageCount: 0 });
  const [assignedFarmer, setAssignedFarmers] = useState([]);
  const [stateId, setStateId] = useState("null");
  const [districtId, setDistrictId] = useState("null");
  const [blockId, setBlockId] = useState("null");
  const [searchKey, setSearchKey] = useState("");
  const [activeCard, setActiveCard] = useState("Farmers");
  // const [acs, setACS] = useState("");
  const [gender, setGender] = useState("");
  const [farmerCategory, setFarmerCategory] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [SelectedFle, setSelectedFle] = useState("");
  const [selectedFpo, setselectedFpo] = useState("");
  const [selectedCrops, setSelectedCrops] = useState([]);
  const [cropQueryString, setcropQueryString] = useState("");
  const [SortField, setSortField] = useState("");
  const [SortType, setSortType] = useState("");
  const [range, setRange] = useState(null);
  const [dateValue, setDateValue] = useState(null);

  const { data: data, isLoading, refetch } = useGetFarmersQuery(
    {
      orgId,
      page: pagination.page,
      per_page: pagination.per_page,
      stateId,
      districtId,
      blockId,
      searchKey: debouncedSearch || "",
      farmerCategory,
      gender,
      SelectedFle,
      cropQueryString,
      SortField,
      SortType,
      selectedFpo,
      range,
    },
    { refetchOnMountOrArgChange: true, pollingInterval: 900000 },
  );
  const {
    data: AssignedFarmerList,
    isLoading: AssignedFarmerLoading,
    // refetch: FarmerListRefetch,
  } = useGetAssignedFarmersQuery(
    {
      orgId,
      paginationAss,
      searchKey: debouncedSearch || "",
    },
    { skip: activeCard !== "Assigned Farmers" },
  );
  const { data: FleList } = useGetSaathiFLEQuery(
    { districtId: "", searchKey: "" },
    { refetchOnMountOrArgChange: true },
  );
  const { data: Fpolist } = useGetFPOListQuery(
    { pagination: "", searchKey: "", orgId },
    { refetchOnMountOrArgChange: true },
  );

  const { data: getStates } = useGetStatesQuery();
  const canCall = { stateId: stateId, districtId: districtId };
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId, {
    skip: !canCall.stateId,
  });
  const { data: dataBlock } = useGetBlockByDistrictQuery(districtId, {
    skip: !canCall.districtId,
  });
  const { data: cropList } = useGetCropListQuery();

  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [FleData, setFleList] = useState([]);
  const [FpoList, setFpoList] = useState([]);

  const columns = [
    { field: "full_name", headerName: "Name", width: 150 },
    {
      field: "created_at",
      headerName: "Onboarding Date",
      width: 150,
      renderCell: (cellvalues) => {
        return (
          <div>
            {" "}
            {cellvalues.row.created_at
              ? cellvalues.row.created_at.slice(0, 10)
              : ""}{" "}
          </div>
        );
      },
    },
    { field: "phone_number", headerName: "Mobile", width: 120 },
    { field: "gender", headerName: "Gender", width: 80 },
    {
      field: "age",
      headerName: "Age",
      width: 50,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "farmer_category",
      headerName: "Category",
      width: 200,
      renderCell: (cellValues) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",

            fontSize: "14px",
          }}
          title={cellValues?.row?.farmer_category || ""}
        >
          {(cellValues?.row?.farmer_category || "").length > 50
            ? `${cellValues?.row?.farmer_category.substring(0, 50)}...`
            : cellValues?.row?.farmer_category || ""}
        </div>
      ),
    },

    {
      field: "total_land_holding",
      headerName: "Declared Landholding",
      width: 110,
      renderCell: (cellvalues) => {
        return (
          <div>
            {cellvalues.row.total_land_holding} &nbsp;
            {cellvalues.row.unit_of_land_holding}
          </div>
        );
      },
    },

    {
      field: "total_acs",
      headerName:
        RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV")
          ? "Farm Score"
          : "ACS",
      width: 100,
      renderCell: (cellvalues) => {
        return <div>{cellvalues.row.total_acs.toFixed(2)}</div>;
      },
    },

    // {
    //   field: "current_status",
    //   headerName: "Status",
    //   width: 280,
    //   renderCell: (cellValues) => {
    //     const status = cellValues.row.current_status;
    //     const text = cellValues.row.current_status.replaceAll("_", " ");

    //     const statusConfig = {
    //       "PERSONAL DETAILS ADDED": {
    //         color: "blue",
    //         icon: <FileTextOutlined />,
    //       },
    //       Assigned: { color: "gold", icon: <CheckCircleOutlined /> },
    //       "CATTLE IMAGES ADDED": { color: "error", icon: <WarningOutlined /> },
    //       "Lead Generated": { color: "volcano", icon: <FileTextOutlined /> },
    //     };

    //     const { color, icon } = statusConfig[status] || {
    //       color: "geekblue",
    //       icon: <FileTextOutlined />,
    //     };

    //     return (
    //       <Tag
    //         bordered={false}
    //         color={color}
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "8px",
    //           padding: "3px 9px",
    //           fontSize: "13px",
    //           fontWeight: "500",
    //           borderRadius: "6px",
    //         }}
    //       >
    //         {icon}
    //         <span>{text?text:"-"}</span>
    //       </Tag>
    //     );
    //   },
    // },

    // {
    //   field: "state_name",
    //   headerName: "Location",
    //   width: 250,
    //   renderCell: (cellValues) => {
    //     const fullAddress = `${cellValues?.row?.address || ""}`;
    //     const truncatedAddress =
    //       fullAddress?.length > 50
    //         ? `${fullAddress.substring(0, 60)}...`
    //         : fullAddress;

    //     return (
    //       <div
    //         style={{
    //           whiteSpace: "normal",
    //           wordWrap: "break-word",
    //           maxWidth: "220px",
    //           fontSize: "12px",
    //         }}
    //         title={fullAddress}
    //       >
    //         {truncatedAddress}
    //       </div>
    //     );
    //   },
    // },

    { field: "state_name", headerName: "State Name", width: 130 },
    {
      field: "district_name",
      headerName: "District Name",
      width: 140,
      renderCell: (cellValues) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "140px",
            fontSize: "13px",
          }}
          title={cellValues?.row?.district_name || ""}
        >
          {(cellValues?.row?.district_name || "").length > 50
            ? `${cellValues?.row?.district_name.substring(0, 50)}...`
            : cellValues?.row?.district_name || ""}
        </div>
      ),
    },

    {
      field: "action",
      headerName: "Action",
      width: 60,
      renderCell: (cellvalues) => {
        return (
          <>
            <FontAwesomeIcon
              icon={faPenToSquare}
              className="mx-2"
              style={{ color: "orange", fontSize: "16px", cursor: "pointer" }}
              onClick={() => {
                RoleAcessParams.includes("HCL") ||
                RoleAcessParams.includes("UP_GOV") ||
                noSidebar
                  ? navigate(`/farmerDetail/onboarding/${cellvalues.row.id}`, {
                      replace: true,
                      state: {
                        fullname: cellvalues.row.full_name,
                      },
                    })
                  : navigate(`/onboarding/farmers/${cellvalues.row.id}`, {
                      state: {
                        fullname: cellvalues.row.full_name,
                        // active: "Farm",
                      },
                    });
              }}
            />
          </>
        );
      },
    },
  ];

  const AssignedFarmercolumns = [
    { field: "full_name", headerName: "Name", width: 150 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 130,
      renderCell: (cellvalues) => {
        return (
          <div>
            {" "}
            {cellvalues.row.created_at
              ? cellvalues.row.created_at.slice(0, 10)
              : ""}{" "}
          </div>
        );
      },
    },
    { field: "phone_number", headerName: "Mobile", width: 120 },
    {
      field: "assigned_details",
      headerName: "FLE Name",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: (params) => (
        <span>
          {params.row.assigned_details.length > 0 && (
            <span>
              {
                params.row.assigned_details[
                  params.row.assigned_details.length - 1
                ].agent_name
              }
            </span>
          )}
        </span>
      ),
    },
    { field: "gender", headerName: "Gender", width: 100 },

    {
      field: "current_status",
      headerName: " Status",
      width: 280, // Slightly increased width for better layout
      renderCell: (cellValues) => {
        const status = cellValues.row.current_status;
        const text = cellValues.row.current_status.replaceAll("_", " ");

        const statusConfig = {
          "PERSONAL DETAILS ADDED": {
            color: "blue",
            icon: <FileTextOutlined />,
          },
          Assigned: { color: "gold", icon: <CheckCircleOutlined /> },
          "CATTLE IMAGES ADDED": { color: "error", icon: <WarningOutlined /> },
          "Lead Generated": { color: "volcano", icon: <FileTextOutlined /> },
        };

        const { color, icon } = statusConfig[status] || {
          color: "geekblue",
          icon: <FileTextOutlined />,
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px", // Adds subtle rounding
            }}
          >
            {icon}
            <span>{text ? text : "-"}</span>
          </Tag>
        );
      },
    },
    // {
    //   field: "state_name",
    //   headerName: "Location",
    //   width: 250,
    //   renderCell: (cellValues) => {
    //     const fullAddress = `${cellValues?.row?.address || ""}`;
    //     const truncatedAddress =
    //       fullAddress?.length > 50
    //         ? `${fullAddress.substring(0, 60)}...`
    //         : fullAddress;
    //     return (
    //       <div
    //         style={{
    //           whiteSpace: "normal",
    //           wordWrap: "break-word",
    //           maxWidth: "220px",
    //           fontSize: "12px",
    //         }}
    //         title={fullAddress}
    //       >
    //         {truncatedAddress}
    //       </div>
    //     );
    //   },
    // },
    { field: "state_name", headerName: "State Name", width: 130 },
    {
      field: "district_name",
      headerName: "District Name",
      width: 140,
      renderCell: (cellValues) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "140px",
            fontSize: "13px",
          }}
          title={cellValues?.row?.district_name || ""}
        >
          {(cellValues?.row?.district_name || "").length > 50
            ? `${cellValues?.row?.district_name.substring(0, 50)}...`
            : cellValues?.row?.district_name || ""}
        </div>
      ),
    },

    {
      field: "action",
      headerName: "Action",
      width: 60,
      renderCell: (cellvalues) => {
        return (
          <Link to={cellvalues.row.id}>
            {" "}
            <FontAwesomeIcon
              icon={faPenToSquare}
              className="mx-2"
              style={{ color: "orange", fontSize: "16px" }}
            />{" "}
          </Link>
        );
      },
    },
  ];

  useEffect(() => {
    if (data != undefined) {
      const GeojsonData = data?.data?.geojson ? data?.data?.geojson : null;
      // const paginationFromApi = data?.data?.pages
      //   ? {
      //       page: data?.data?.current_page,
      //       pageCount: data?.data?.pages,
      //       per_page: data?.data?.per_page,
      //     }
      //   : pagination;

      const currentPage = data?.data?.current_page || pagination.page;
      const totalPages = data?.data?.pages || pagination.pageCount;
      const perPageFromApi = data?.data?.per_page || pagination.perPage;
      setPagination((prev) => {
        if (
          prev.page !== currentPage ||
          prev.pageCount !== totalPages ||
          prev.perPage !== perPageFromApi
        ) {
          return {
            page: currentPage,
            pageCount: totalPages,
            perPage: perPageFromApi,
          };
        }
        return prev;
      });
      setFarmers(data?.data?.results);
      // setPagination(paginationFromApi);
      setGeojsonData(GeojsonData);
      setGeojsonInParent(GeojsonData);
    }
  }, [data]);
  useEffect(() => {
    if (FleList != undefined) {
      setFleList(FleList?.data?.results);
    }
    if (Fpolist != undefined) {
      setFpoList(Fpolist?.data?.results);
    }
  }, [FleList, Fpolist]);
  const optionCrop = [
    {
      label: "Crop",
      options: cropList?.data?.results?.map((crop) => ({
        label: `${crop.crop_name}`,
        value: `${crop.crop_name}`,
      })),
    },
  ];
  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, page: value }));
    // setFarmers(value);
  };
  const handlePageChange2 = (event, value) => {
    setPaginationAss((prev) => ({ ...prev, page: value }));
    // setFarmers(value);
  };

  useEffect(() => {
    const ApiData = AssignedFarmerList?.data?.results
      ? AssignedFarmerList?.data?.results
      : [];
    const paginationFromApi = AssignedFarmerList?.data?.pages
      ? {
          page: AssignedFarmerList?.data?.current_page,
          pageCount: AssignedFarmerList?.data?.pages,
        }
      : paginationAss;
    setAssignedFarmers(ApiData);
    setPaginationAss(paginationFromApi);
  }, [AssignedFarmerList]);

  const pathName = window.location.pathname.split("/");
  const moduleName = pathName[pathName.length - 1];
  const moduleNameFromgPath =
    moduleName.charAt(0).toUpperCase() + moduleName.slice(1);
  const dispatch = useDispatch();
  useEffect(() => {
    const breadcrumbs = [
      { name: "Dashboard", link: "/dashboard" },
      { name: moduleNameFromgPath },
    ];

    dispatch(setBreadcrumbs(breadcrumbs));
  }, []);

  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     minHeight: "35px",
  //     height: "35px",
  //     padding: "0px",
  //     fontSize: "13px",
  //     zIndex: 100,
  //   }),
  //   menu: (provided) => ({
  //     ...provided,
  //     zIndex: 3000,
  //   }),
  // };
  //  const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     minHeight: "35px",
  //     height: "35px",
  //     fontSize: "13px",
  //     zIndex: 100,
  //   }),
  //   valueContainer: (provided) => ({
  //     ...provided,
  //     height: "35px",
  //     padding: "0 6px",
  //   }),
  //   input: (provided) => ({
  //     ...provided,
  //     margin: 0,
  //     padding: 0,
  //   }),
  //   singleValue: (provided) => ({
  //     ...provided,
  //     lineHeight: "35px",
  //   }),
  //   indicatorsContainer: (provided) => ({
  //     ...provided,
  //     height: "35px",
  //   }),
  //   menu: (provided) => ({
  //     ...provided,
  //     zIndex: 3000,
  //   }),
  // };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "38px",
      height: "38px",
      borderRadius: "8px",
      fontSize: "13px",
      padding: "0 2px",
      transition: "all 0.2s ease",
      zIndex: 100,
      alignItems: "center",
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
      height: "38px",
    }),

    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      height: "auto",
    }),

    indicatorsContainer: (provided) => ({
      ...provided,
      height: "38px",
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "6px",
      transition: "color 0.2s ease",
    }),

    clearIndicator: (provided) => ({
      ...provided,
      padding: "6px",
      color: "#9ca3af",
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      marginTop: 4,
      fontSize: "13px",
      zIndex: 3000,
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      padding: "8px 10px",

      cursor: "pointer",
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#9ca3af",
      marginLeft: 2,
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#111827",
      marginLeft: 2,
      lineHeight: "1",
    }),
  };

  useEffect(() => {
    if (getStates != undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };
  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };
  const onLocationChange = (event) => {
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
    if (event.ConditionName == "state") {
      setBlockId("null");
      setDistrictName("");
      setDistrictId("null");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("null");
      setBlockName("");
    }
    if (event.ConditionName == "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };
  useEffect(() => {
    if (stateId !== "" || districtId !== "" || blockId !== "") {
      refetch();
    }
  }, [stateId, districtId, blockId]);
  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock != undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500); // 500ms debounce time

    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (message) => {
    setSearchKey(message);

    setPagination({ page: 1, pageCount: 0, per_page: 50 });
  };

  const handleChange = (event, newValue) => {
    setActiveCard(newValue);
  };

  const [season, setSeason] = useState("Kharif");
  const [chartData, setChartData] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedAlias, setSelectedAlias] = useState(null);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleDateChange = (value) => {
    console.log("Selected Date Range:", value);
    setDateValue(value);

    if (value) {
      const formattedRange = `${formatDate(value[0])},${formatDate(value[1])}`;
      console.log("formattedRange", formattedRange);
      setRange(formattedRange);
    } else {
      setRange(null);
    }
  };
  console.log("projectExist", projectExist);
  return (
    <>
      {/* {showMap && (
        <Card style={{ marginTop: "-1%", height: "65svh" }}>
          <CardBody className="p-1 p-lg-3">
            {isLoading ? (
              <Skeleton count={20} />
            ) : (
              <FarmerMap
                showGeojson={showGeojson}
                projectExist={projectExist}
              />
            )}
          </CardBody>
        </Card>
      )}

      {!showMap && !projectExist && (
        <Card className="" style={{ height: "60svh" }}>
          <CardBody className="p-1 p-lg-3">
            <HCLMap
              showGeojson={showGeojson}
              RoleAcessParams={RoleAcessParams}
            />
          </CardBody>
        </Card>
      )}
      {!showMap && projectExist && (
        <div className="row">
          <div
            className={
              projectExist?.analytics?.analytics ? "col-lg-9" : "col-lg-12"
            }
          >
            <Card className="" style={{ height: "60svh" }}>
              <CardBody className="p-1 p-lg-3">
                <ProjectMap
                  showGeojson={showGeojson}
                  projectExist={projectExist}
                  type={selectedIndex}
                  data={chartData}
                  season={season}
                  setSelectedAlias={setSelectedAlias}
                  selectedAlias={selectedAlias}
                />
              </CardBody>
            </Card>
          </div> */}
      {showMap ? (
        <Card style={{ marginTop: "-1%", height: "65svh" }}>
          <CardBody className="p-1 p-lg-3">
            {isLoading ? (
              <Skeleton count={20} />
            ) : (
              <FarmerMap
                showGeojson={showGeojson}
                projectExist={projectExist}
              />
            )}
          </CardBody>
        </Card>
      ) : !showMap && projectExist?.project_name === "Project MAATI" ? (
        <Card className="" style={{ height: "60svh" }}>
          <CardBody className="p-1 p-lg-3">
            <HCLMap
              showGeojson={showGeojson}
              projectExist={projectExist}
              type={selectedIndex}
              data={chartData}
              season={season}
              setSelectedAlias={setSelectedAlias}
              selectedAlias={selectedAlias}
            />
          </CardBody>
        </Card>
      ) : (
        !showMap &&
        projectExist && (
          <div className="row">
            <div
              className={
                projectExist?.analytics?.analytics ? "col-lg-9" : "col-lg-12"
              }
            >
              <Card className="" style={{ height: "60svh" }}>
                <CardBody className="p-1 p-lg-3">
                  <ProjectMap
                    showGeojson={showGeojson}
                    projectExist={projectExist}
                    type={selectedIndex}
                    data={chartData}
                    season={season}
                    setSelectedAlias={setSelectedAlias}
                    selectedAlias={selectedAlias}
                  />
                </CardBody>
              </Card>
            </div>
            {projectExist?.analytics?.analytics && (
              <div className="col-lg-3 ">
                <ProjectSideAnalytics
                  projectExist={projectExist}
                  setChartData={setChartData}
                  chartData={chartData}
                  setSelectedIndex={setSelectedIndex}
                  selectedIndex={selectedIndex}
                  setSelectedAlias={setSelectedAlias}
                  selectedAlias={selectedAlias}
                />
                <></>
              </div>
            )}
            {chartData && selectedIndex && (
              <div className="col-lg-12">
                <div className="mt-3">
                  <ProjectCharts type={selectedIndex} data={chartData} />
                </div>
              </div>
            )}
          </div>
        )
      )}

      <div>
        {RoleAcessParams.includes("CBBO") ||
        RoleAcessParams.includes("FPO") ||
        id ? (
          ""
        ) : (
          <div
            className="container_tabs p-1 mb-3"
            style={{ borderRadius: "5px" }}
          >
            <Tabs
              value={activeCard}
              onChange={handleChange}
              aria-label="basic tabs example"
              textColor="primary"
              indicatorColor="primary"
              className="mx-3 mt-2"
              variant="scrollable"
            >
              <Tab
                label="Farmers"
                value="Farmers"
                className="f14"
                iconPosition="start"
              />
              {!RoleAcessParams.includes("FPO") && (
                <Tab
                  label="Assigned Farmers"
                  value="Assigned Farmers"
                  iconPosition="start"
                  className="f14"
                />
              )}
              {RoleAcessParams.includes("admin") && (
                <Tab
                  label="Farmer Request"
                  value="Farmer Request"
                  iconPosition="start"
                  className="f14"
                />
              )}
              <Tab
                label="Task Details"
                value="Task Details"
                iconPosition="start"
                className="f14"
              />
            </Tabs>
          </div>
        )}
        <>
          {activeCard === "Farmers" ? (
            <Card className="transparent_card">
              <CardBody className="p-1 p-lg-3 ">
                <div className="">
                  <>
                    <Row className="mt-1 px-1 mb-2">
                      <Col
                        xs="7"
                        md="6"
                        lg="2"
                        className="d-flex justify-content-start mb-lg-0 mb-2"
                      >
                        <CustomSearchBar
                          sendSearchFunction={handleChangeSearch}
                        />
                      </Col>

                      <Col xs="5" md="6" lg="2" className="mb-lg-0 mb-2">
                        <div className="mt-2 d-flex justify-content-end">
                          {" "}
                          Total Farmers :
                          <span className="text-success">
                            &nbsp;{data?.data?.total}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs="12"
                        md="6"
                        lg="8"
                        className="d-flex flex-lg-row flex-column justify-content-end flex-wrap"
                      >
                        <ListViewActionItems
                          orgId={orgId}
                          refetch={refetch}
                          RoleAcessParams={RoleAcessParams}
                          currentUser={currentUser}
                          farmers={farmers}
                          stateId={stateId}
                          districtId={districtId}
                          blockId={blockId}
                          searchKey={searchKey}
                          farmerCategory={farmerCategory}
                          gender={gender}
                          setPagination={setPagination}
                          showFields={true}
                          SelectedFle={SelectedFle}
                          cropQueryString={cropQueryString}
                          selectedFpo={selectedFpo}
                          range={range}
                          SortField={SortField}
                          SortType={SortType}
                        />
                      </Col>
                    </Row>
                    <CardHeader>
                      <Row className="mt-3 w-full">
                        <Col
                          xs={12}
                          sm={6}
                          md={4}
                          lg="2"
                          className="position-relative mb-2"
                        >
                          <Select
                            menuPlacement="auto"
                            options={handleStateOptions()}
                            placeholder={
                              stateId === "null" ? "State" : stateName
                            }
                            value={
                              stateId === "null" ? "Select State" : stateName
                            }
                            onChange={onLocationChange}
                            styles={customStyles}
                          />
                          {stateId !== "null" && (
                            <span
                              className="clear-icon"
                              onClick={() => {
                                setStateId("null");
                                setStateName("null");
                                setDistrictId("null");
                                setDistrictName("null");
                              }}
                              style={{
                                position: "absolute",
                                top: "54%",
                                right: "60px",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "gray",
                                fontSize: "12px",
                                zIndex: 1000,
                              }}
                            >
                              ✕
                            </span>
                          )}
                        </Col>

                        {/* District */}
                        <Col
                          xs={12}
                          sm={6}
                          md={4}
                          lg="2"
                          className="position-relative mb-2"
                        >
                          <Select
                            menuPlacement="auto"
                            options={handleDistrictOptions()}
                            placeholder={
                              districtId === "null" ? "District" : districtName
                            }
                            value={
                              districtId === "null"
                                ? "Select District"
                                : districtName
                            }
                            onChange={onLocationChange}
                            styles={customStyles}
                          />
                          {districtId !== "null" && (
                            <span
                              className="clear-icon"
                              onClick={() => {
                                setDistrictId("null");
                                setDistrictName("null");
                              }}
                              style={{
                                position: "absolute",
                                top: "54%",
                                right: "60px",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "gray",
                                fontSize: "12px",
                                zIndex: 1000,
                              }}
                            >
                              ✕
                            </span>
                          )}
                        </Col>

                        <Col
                          xs={12}
                          sm={6}
                          md={4}
                          lg="2"
                          className="position-relative mb-2"
                          style={{ flex: "0 0 12.5%" }}
                        >
                          <Select
                            menuPlacement="auto"
                            options={[
                              { value: "Male", label: "Male" },
                              { value: "Female", label: "Female" },
                              { value: "Others", label: "Others" },
                            ]}
                            placeholder={gender === "" ? "Gender" : gender}
                            value={gender === "" ? "Gender" : gender}
                            onChange={(selected) => {
                              setGender(selected?.value || null);
                              setPagination({
                                page: 1,
                                pageCount: 0,
                                per_page: 50,
                              });
                            }}
                            styles={customStyles}
                          />
                          {gender && (
                            <span
                              className="clear-icon"
                              onClick={() => setGender("")}
                              style={{
                                position: "absolute",
                                top: "54%",
                                right: "60px",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "gray",
                                fontSize: "12px",
                                zIndex: 1000,
                              }}
                            >
                              ✕
                            </span>
                          )}
                        </Col>

                        <Col
                          xs={12}
                          sm={6}
                          md={6}
                          lg="2"
                          className="position-relative mb-2"
                        >
                          <Select
                            menuPlacement="auto"
                            options={[
                              {
                                value: "Marginal",
                                label: "Marginal (Less than 2.5 acres)",
                              },
                              {
                                value: "Small",
                                label: "Small (2.5–5 acres)",
                              },
                              {
                                value: "Semi Medium",
                                label: "Semi Medium (5–10 acres)",
                              },
                              {
                                value: "Medium",
                                label: "Medium (10–25 acres)",
                              },
                              {
                                value: "Large",
                                label: "Large (25 acres and above)",
                              },
                            ]}
                            placeholder={
                              farmerCategory === ""
                                ? "Category"
                                : farmerCategory
                            }
                            value={
                              farmerCategory === ""
                                ? "Category"
                                : farmerCategory
                            }
                            onChange={(selected) => {
                              setFarmerCategory(selected?.value || null);
                              setPagination({
                                page: 1,
                                pageCount: 0,
                                per_page: 50,
                              });
                            }}
                            styles={customStyles}
                          />
                          {farmerCategory && (
                            <span
                              className="clear-icon"
                              onClick={() => setFarmerCategory("")}
                              style={{
                                position: "absolute",
                                top: "54%",
                                right: "60px",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "gray",
                                fontSize: "12px",
                                zIndex: 1000,
                              }}
                            >
                              ✕
                            </span>
                          )}
                        </Col>

                        {/* FLE and FPO */}
                        {!RoleAcessParams?.includes("FPO") && (
                          <>
                            <Col
                              xs={12}
                              sm={6}
                              md={6}
                              lg="2"
                              className="position-relative mb-2"
                            >
                              <Select
                                menuPlacement="auto"
                                options={
                                  FleData?.map((item) => ({
                                    label: item.full_name,
                                    value: item.id,
                                  })) || []
                                }
                                placeholder="FLE"
                                value={
                                  SelectedFle
                                    ? FleData?.map((item) => ({
                                        label: item.full_name,
                                        value: item.id,
                                      })).find(
                                        (option) =>
                                          option.value === SelectedFle,
                                      )
                                    : null
                                }
                                onChange={(selectedOption) => {
                                  setSelectedFle(selectedOption?.value || "");
                                  setPagination({
                                    page: 1,
                                    pageCount: 0,
                                    per_page: 50,
                                  });
                                }}
                                styles={customStyles}
                              />
                            </Col>

                            <Col
                              xs={10}
                              sm={6}
                              md={6}
                              lg="2"
                              className="position-relative mb-2"
                            >
                              <Select
                                menuPlacement="auto"
                                options={FpoList.map((item) => ({
                                  label: item.organization_name,
                                  value: item.id,
                                }))}
                                placeholder="FPO"
                                value={
                                  FpoList.map((item) => ({
                                    label: item.organization_name,
                                    value: item.id,
                                  })).find(
                                    (option) => option.value === selectedFpo,
                                  ) || null
                                }
                                onChange={(selectedOption) => {
                                  setselectedFpo(selectedOption?.value || "");
                                  setPagination({
                                    page: 1,
                                    pageCount: 0,
                                    per_page: 50,
                                  });
                                }}
                                styles={customStyles}
                              />
                            </Col>
                          </>
                        )}

                        {/* Sort */}
                        <Col
                          xs={2}
                          sm={6}
                          md={4}
                          lg="1"
                          className="mb-2"
                          style={{ flex: "0 0 4.16%" }}
                        >
                          <SortDropdown
                            onSortChange={({ field, direction }) => {
                              setSortField(field);
                              setSortType(direction);
                            }}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="9" className="d-flex flex-wrap gap-2">
                          <Col
                            xs={12}
                            sm={6}
                            lg="4"
                            className="mb-2 mt-2 position-relative"
                          >
                            <Select
                              isMulti
                              value={selectedCrops}
                              onChange={(selectedOptions) => {
                                setSelectedCrops(selectedOptions);
                                setcropQueryString(
                                  selectedOptions
                                    .map((opt) => opt.value)
                                    .join(","),
                                );
                              }}
                              options={optionCrop}
                              styles={customStyles}
                            />
                          </Col>

                          <Col xs={12} sm={6} lg="3" className="mb-2 mt-2">
                            <DateRangePicker
                              className="custom-date-picker"
                              size="lg"
                              style={{ width: "100%" }}
                              value={dateValue}
                              onChange={handleDateChange}
                              placeholder="Select date range"
                              cleanable
                            />
                          </Col>
                        </Col>
                      </Row>
                    </CardHeader>
                  </>
                </div>
                <div>
                  <div className=" py-3 d-lg-none d-md-none d-block">
                    <div className="d-flex flex-lg-row flex-md-row flex-wrap  d-lg-none d-md-block d-block">
                      {isLoading ? (
                        <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                          <h5>Loading...</h5>
                        </div>
                      ) : farmers.length > 0 ? (
                        farmers.map((farmer) => (
                          <div
                            className="card mb-3 col-lg-3 col-md-6 col-12 shadow-sm rounded-3 custom-hover-effect"
                            key={farmer.id}
                          >
                            <div className="card-body p-3 fpo_card position-relative">
                              <div
                                className="d-flex align-items-center py-2 gap-3"
                                style={{ borderBottom: "1px solid #ebeaeab5" }}
                              >
                                <div>
                                  <h5 className="text-success m-0 text-capitalize">
                                    {farmer?.full_name || "N/A"}
                                  </h5>
                                  <div className="d-flex">
                                    <h6 style={{ color: "#5c5c5cb3" }}>
                                      {farmer.primary_occupation}
                                    </h6>
                                  </div>
                                </div>
                                <button
                                  className="btn btn-outline-primary position-absolute"
                                  style={{ right: "4%", top: "10%" }}
                                  onClick={() => {
                                    navigate(
                                      `/onboarding/farmers/${farmer.id}`,
                                      {
                                        state: { fullname: farmer.full_name },
                                      },
                                    );
                                  }}
                                >
                                  View
                                </button>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mt-1">
                                <span className="card-text d-flex gap-1 mt-1">
                                  <i className="mdi mdi-phone text-warning me-2 fs-6"></i>
                                  <h6>Phone:</h6>{" "}
                                  {farmer?.phone_number || "N/A"}
                                </span>
                                <span className="card-text d-flex gap-1 mt-1">
                                  <i className="mdi mdi-gender-male-female text-secondary me-2 fs-6"></i>
                                  <h6>Gender:</h6> {farmer?.gender || "N/A"}
                                </span>
                              </div>

                              <span className="card-text d-flex gap-1 mt-1">
                                <i className="mdi mdi-calendar-clock text-info me-2 fs-6"></i>
                                <h6>Joined:</h6>{" "}
                                {farmer.created_at
                                  ? farmer.created_at.slice(0, 10)
                                  : "N/A"}
                              </span>
                              <span className="card-text d-flex gap-1 mt-1">
                                <i className="mdi mdi-map-marker text-danger me-2 fs-6"></i>
                                {farmer?.address || "N/A"}
                              </span>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <span className="card-text d-flex gap-1">
                                  <i className="mdi mdi-information text-success me-2 fs-6"></i>
                                  <h6>Status:</h6>{" "}
                                  <Tag
                                    bordered={false}
                                    style={{ fontWeight: "500" }}
                                    color="geekblue"
                                  >
                                    {farmer.current_status
                                      .replaceAll("_", " ")
                                      .slice(0, 30)}
                                    {farmer.current_status.length > 30
                                      ? "..."
                                      : ""}
                                  </Tag>
                                </span>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                          <h5>No Data Available</h5>
                        </div>
                      )}
                    </div>
                    <Pagination
                      count={pagination.pageCount}
                      page={pagination.page}
                      onChange={handlePageChange}
                      variant="outlined"
                      shape="rounded"
                    />
                  </div>
                  <div className="d-lg-block d-md-block d-none">
                    <ListViewContainer
                      showHeaderSection={true}
                      searchBar={true}
                      tableData={{
                        rows: farmers,
                        columns: columns,
                        paginationState: [pagination, setPagination],
                        isLoading: isLoading,
                        checkboxShowFalse: true,
                      }}
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          ) : activeCard === "Farmer Request" ? (
            <Card className="transparent_card">
              <CardBody className="p-1 p-lg-3">
                <FarmerRequest />
              </CardBody>
            </Card>
          ) : activeCard === "Assigned Farmers" ? (
            <Card className="transparent_card">
              <CardBody className="p-1 p-lg-3">
                <div className="">
                  <>
                    <Row className="mt-1 px-1">
                      <Col md="2" lg="2" xs="7">
                        <CustomSearchBar
                          sendSearchFunction={handleChangeSearch}
                        />
                      </Col>
                      <Col md="2" lg="2" xs="8">
                        <div className="mt-2">
                          Total Farmers :
                          <span className="text-success">
                            &nbsp;{AssignedFarmerList?.data?.total}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </>
                </div>
                <div>
                  <div className=" py-3 d-lg-none d-md-none d-block">
                    <div className="row g-1">
                      {assignedFarmer?.length > 0 ? (
                        assignedFarmer?.map((farmer) => (
                          <div
                            className="col-12 col-sm-6 col-md-4 "
                            key={farmer.id}
                          >
                            <div className="card shadow-sm position-relative ">
                              <div className="card-body p-3 fpo_card position-relative">
                                <div className="d-flex align-items-center w-100 mb-2 justify-content-between">
                                  <div>
                                    <h5 className="text-success m-0 text-capitalize">
                                      {farmer?.full_name || "N/A"}
                                    </h5>
                                    <div className="d-flex">
                                      <h6 style={{ color: "#5c5c5cb3" }}>
                                        {farmer.primary_occupation || "N/A"}
                                      </h6>
                                    </div>
                                  </div>
                                  <div className="">
                                    <button
                                      className="btn btn-outline-primary"
                                      onClick={() => {
                                        navigate(
                                          `/onboarding/farmers/${farmer.id}`,
                                          {
                                            state: {
                                              fullname: farmer.full_name,
                                            },
                                          },
                                        );
                                      }}
                                    >
                                      View{" "}
                                    </button>
                                  </div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center w-100">
                                  <div className="d-flex align-items-center  ">
                                    <i
                                      className="mdi mdi-phone  me-2 fs-5"
                                      style={{ color: "#9c9c9c" }}
                                    ></i>
                                    <span>{farmer.phone_number}</span>
                                  </div>
                                  <div className="d-flex align-items-center  ">
                                    <i
                                      className="mdi mdi-gender-male-female   me-2 fs-5"
                                      style={{ color: "#9c9c9c" }}
                                    ></i>
                                    <span>{farmer.gender}</span>
                                  </div>
                                  <div className="d-flex align-items-center  ">
                                    <i
                                      className="mdi mdi-calendar  me-2 fs-5"
                                      style={{ color: "#9c9c9c" }}
                                    ></i>
                                    <span>
                                      {farmer.created_at
                                        ? farmer.created_at.slice(0, 10)
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center  w-100">
                                  <i className="mdi mdi-map-marker text-danger me-2 fs-5"></i>
                                  <span>{farmer?.address}</span>
                                </div>
                                <div className="d-flex align-items-center w-100">
                                  <i className="mdi mdi-account-circle text-orange me-2 fs-5"></i>
                                  <h6 className="mt-1">Assigned to : </h6>
                                  <span className="mx-1">
                                    {farmer?.assigned_details?.length > 0 && (
                                      <span>
                                        {
                                          farmer.assigned_details[
                                            farmer.assigned_details.length - 1
                                          ].agent_name
                                        }
                                      </span>
                                    )}
                                  </span>
                                </div>

                                <div className="d-flex align-items-center w-100 mt-2">
                                  <strong>Current Status:</strong>
                                  <span className="ms-2 text-truncate">
                                    <Tag
                                      bordered={false}
                                      style={{ fontWeight: "500" }}
                                      color="geekblue"
                                    >
                                      {farmer.current_status
                                        .replaceAll("_", " ")
                                        .slice(0, 30)}
                                      {farmer.current_status.length > 30
                                        ? "..."
                                        : ""}
                                    </Tag>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center bg-white shadow rounded-3 d-flex justify-content-center py-5 w-100 mb-3">
                          <h5>No Data Available</h5>
                        </div>
                      )}
                    </div>

                    <Pagination
                      count={paginationAss.pageCount}
                      page={paginationAss.page}
                      onChange={handlePageChange2}
                      variant="outlined"
                      shape="rounded"
                    />
                  </div>
                  <div className="d-lg-block d-md-block d-none">
                    <ListViewContainer
                      showHeaderSection={true}
                      searchBar={true}
                      tableData={{
                        rows: assignedFarmer,
                        columns: AssignedFarmercolumns,
                        paginationState: [paginationAss, setPaginationAss],
                        isLoading: AssignedFarmerLoading,
                        checkboxShowFalse: true,
                      }}
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          ) : (
            <TaskDetails />
          )}
        </>
      </div>
    </>
  );
};
export default FarmerList;
